<ng-content select="[xpShellSidebar]"></ng-content>
<div class="xp-shell__main">
	<ng-content select="[xpShellHeader]"></ng-content>
	<div class="xp-shell__content">
		<ng-content></ng-content>
	</div>
</div>
